import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [totalQty, setTotalQty] = useState(0);
  // useEffect(() => {
  //   // Clear the cart after successful payment
  //   localStorage.removeItem('cart');
  // }, []);
    // In your success page component
useEffect(() => {
    const clearCart = async () => {
        try {
            await fetch('/api/cart/clear', { method: 'POST' });
            localStorage.removeItem('cart');
            setCart([]);
            setTotalQty(0);
        } catch (err) {
            console.error('Error clearing cart:', err);
        }
    };
    
    clearCart();
}, []);

  const navLinks = [
    { text: "TOUR", link: "/#upcoming" },
    { text: "STREAM", link: "/#stream" },
    { text: "RELEASES", link: "/#releases" },
    { text: "SHOP", link: "/#boutique", external: true },
    { text: "ABOUT", link: "/#about" },
  ];

  return (
    <>
      <Header menuItems={navLinks} cartQty={0} />
      
      <Box
        sx={{
          backgroundImage: `url(/images/rainbow_bg.jpg)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          backgroundAttachment: "fixed",
          backgroundPosition: "center bottom",
          minHeight: "100vh",
          display: 'flex',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Container 
          maxWidth="sm" 
          sx={{ 
            bgcolor: "white", 
            opacity: 0.95, 
            p: 5, 
            borderRadius: 2,
            textAlign: 'center'
          }}
        >
          <CheckCircleOutlineIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main',
              mb: 2
            }} 
          />
          
          <Typography variant="h4" gutterBottom>
            <strong>Payment Successful!</strong>
          </Typography>
          
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Thank you for your purchase. You will receive a confirmation email shortly.
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 4 }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() =>  window.location.href = '/'}
            >
              Back to Home
            </Button>
            
            <Button 
              variant="outlined" 
              color="primary"
              onClick={() => window.location.href = '/#boutique'}
            >
              Continue Shopping
            </Button>
          </Box>
        </Container>
      </Box>
      
      <Footer />
    </>
  );
};

export default SuccessPage;